 //const API = "http://localhost:3001";
//const API = "https://fakestoreapi.com";

//const API = "http://127.0.0.1:8000/api";
const API = "https://api.cafedaru.shop/api";
//const API = "http://192.168.1.104:8000/api";

export default API;
